import { actionCreators } from 'react/api/actions/modals';
import { getResourceTo } from 'react/utils/utils';

Greenmile.EventLog = Greenmile.EventLog || {};

Greenmile.EventLog.Manager = function (route, equipment) {

    const getEventsByRestriction = (query, callback) => {
        const ajax = new Monet.Ajax();
        ajax.url = `EventLog/restrictions?criteria=${Greenmile.EventLog.Util.criteria}`;
        ajax.method = 'POST';
        ajax.data = query;
        ajax.success = data => {
            if (route) {
                if (Monet.Session.RouteDetail.screensList[route.id]) {
                  Monet.Session.RouteDetail.screensList[route.id].events = data;
                }
            } else {
                Monet.Session.TrackEquipmentMaps.events = data;
            }
            if (callback) {
                callback();
            }
        };
        ajax.send();
    };

    this.requestEvent = (params) => {
        let { callback, beginData, endDate, eventId } = params;

        if (!beginData && !endDate) {
            const screenSelector = (route ? '#routeMapContainer_' + route.id : '#TrackEquipmentMaps');
            const interval = App.Views.TrackEquipmentMaps.getDateTimeInterval(screenSelector);
            beginData = interval.timeStart;
            endDate = interval.timeEnd;
        }

        const query = (route) ?
            this.queryToGetRouteEvents(route) :
            this.queryToGetEquipmentEvents(equipment);

        if (query) {
            this.addDatesToQuery(query, route, beginData, endDate);
            this.addEventId(query, eventId);

            getEventsByRestriction(query, callback);
        }

        return query;
    };


    this.addEventId = (query, eventId) => {
        if (eventId) {
            query.criteriaChain[0].or = [{ "attr": "id", "eq": eventId }];
        }
    };

    this.addDatesToQuery = (query, route, beginData, endDate) => {
        beginData = beginData.trim();
        if (beginData) {
            query.criteriaChain[0].and.push({ "attr": "timeValuedTrue", "gte": beginData });
        } else if (route && route.actualStart) {
            query.criteriaChain[0].and.push({ "attr": "timeValuedTrue", "gte": route.actualStart });
        }

        endDate = endDate.trim();
        if (endDate) {
            query.criteriaChain[0].and.push({ "attr": "timeValuedTrue", "lte": endDate });
        } else if (route && route.actualComplete) {
            query.criteriaChain[0].and.push({ "attr": "timeValuedTrue", "lte": route.actualComplete });
        }
    };

    this.queryToGetRouteEvents = (route) => {

        let query = null;

        if (route.id) {
            query = { criteriaChain: [] };
            query.criteriaChain.push({ 'and': [{ 'attr': 'route.id', 'eq': route.id }] });
            const arrayIdsOfEquipment = [];
            if (route.equipmentAssignments) {
                for (let i = 0; i < route.equipmentAssignments.length; i++) {
                    arrayIdsOfEquipment.push(route.equipmentAssignments[i].equipment.id);
                }
                query.criteriaChain[0].and.push({ "attr": "equipment.id", "in": arrayIdsOfEquipment });
            }

            const screenList = Monet.Session.RouteDetail.screensList[route.id];
            const values = screenList.eventsFilter;
            if (values && values.length) {
                const eventTypeIds = values.map(value => (value.id));
                query.criteriaChain[0].and.push({ 'attr': 'event.eventType.id', 'in': eventTypeIds });
            }
        }
        return query;
    };

    this.queryToGetEquipmentEvents = (equipment) => {

        let query = null;
        if (equipment.id) {
            query = {
                criteriaChain: []
            };
            query.criteriaChain.push({ "and": [{ "attr": "equipment.id", "eq": equipment.id }] });
        }

        return query;
    };

    this.addEventsOnMap = (map, events, currentTab, callback) => {

        const checks = (new Greenmile.Storage.StoreMapPosition()).getLayerMapFromUser();

        if (currentTab === "Maps") {
            return;
        }

        if (map.eventId) {
            checks.event_route = true;
            checks.event_equipment = true;
            map.on('popupopen', (event) => {
                // Focus on map
                const px = map.project(event.popup._latlng);
                px.y -= event.popup._container.clientHeight / 2
                map.panTo(map.unproject(px), { animate: true });
            });
        }

        if (!(checks && ((!checks.event_route && route) || (!checks.event_equipment && equipment)))) {

            const cluster = new L.MarkerClusterGroup();
            cluster.kind = 'TRACK_EVENTS';

            let focusedMarker;

            events.forEach(event => {

                let { latitude, longitude, stop } = event;

                if (!(latitude && longitude) && stop && stop.latitude) {
                    latitude = event.stop.latitude;
                    longitude = event.stop.longitude;
                }

                if (latitude && longitude) {

                    const icon = (event.event && event.event.icon) ?
                        event.event.icon :
                        'images/event/software-update-urgent-3.png';
                    const marker = L.marker([latitude, longitude], {
                        icon: new L.Icon({
                            iconUrl: require("./../../../static/" + icon),
                            iconAnchor: [0, 22],
                            popupAnchor: [36, 25]
                        }),
                        zIndexOffset: 99
                    });

                    marker.id = `${currentTab}_${event.id}`;
                    marker.kind = "EVENT";
                    marker.event = event;
                    if (route) {
                        event.route = route;
                        if (route.equipmentAssignments && route.equipmentAssignments.length > 0) {
                            event.equipment = route.equipmentAssignments[0].equipment;
                        }
                    }
                    marker.on('click', () => {
                        const { event } = marker;
                        GreenmileReduxStore.dispatch(actionCreators.openModal({
                            modalKey: 'eventDetails',
                            title: getResourceTo('eventDetails.modal.title', 'Event Details'),
                            data: {
                            eventLogId: String(event.id)
                            }
                        }));
                    })

                    if (map.eventId && (String(map.eventId) === String(event.id))) {
                        focusedMarker = marker;
                    } else {
                        cluster.addLayer(marker);
                    }
                }

            });

            cluster.addTo(map);
            if (focusedMarker) {
                map.addLayer(focusedMarker);
            }
        }

        if (callback) {
            callback();
        }

    };

    this.cleanMarkerEvent = function (map) {
        const layers = map._layers;

        for (let keyLayer in layers) {

            const layer = layers[keyLayer];
            if (layer.kind === "TRACK_EVENTS" && layer.clearLayers) {
                layer.clearLayers();
            }
        }
    };

};
